exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".structure h1[data-v-e939253a]{font-size:28px;font-weight:700}.structure img[data-v-e939253a]{max-width:100%}", ""]);

// exports
